module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/theme-text@2x-65dafb033cff7b9bed037c43aabfe6bd.png";